import { writeDomainCookie, readDomainCookie } from './domain_cookie';
import { sendSegmentEvent } from '../lib/segment';
import partnersData, { PartnerTile } from './partners.data';

// TODO -- this should be cleaned up post release
const isPartnersLive: boolean = true;
const isSitterPartnersLive: boolean = true;

const shuffleArray = (array) => {
  const returnArray = [...array];
  for (let i = returnArray.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = returnArray[i];
    returnArray[i] = returnArray[j];
    returnArray[j] = temp;
  }
  return returnArray;
};

function getCookieName(userIdentifier, key) {
  return `user_${userIdentifier || 'anonymous'}_partner_${key}`;
}

function sendPartnerSegmentEvent(eventName: string, partnerKey: string) {
  const tile: PartnerTile = partnersData.ALL_TILES()[partnerKey];
  if (tile) {
    sendSegmentEvent(eventName, {
      partnerTileName: partnerKey,
      partnerName: tile.companyName,
      ctaUrl: tile.ctaLink,
      partnerCategory: tile.category,
    });
  }
}

function partnerClicked(partnerKey: string): void {
  sendPartnerSegmentEvent('Partner Clicked', partnerKey);
}

function dismissPartner(userIdentifier, partnerKey): void {
  writeDomainCookie(getCookieName(userIdentifier, partnerKey), 'dismissed', { expires: 60 }); // 60 days
  sendPartnerSegmentEvent('Partner Dismissed', partnerKey);
}

function getPartners(userID: string | null, count: number = 2, ignoreCookies = false, omittedKeys?: string[]): string[] {
  let activePartners = [...partnersData.ALL_PARENT_PARTNER_KEYS];
  const partnersToDisplay = [] as Array<string>;
  activePartners = shuffleArray(activePartners);
  // eslint-disable-next-line no-restricted-syntax
  for (const candidateKey of activePartners) {
    const doNotSearchCookie = ignoreCookies || omittedKeys?.includes(candidateKey);
    const cookie = doNotSearchCookie ? null : readDomainCookie(getCookieName(userID, candidateKey));
    if (!cookie && !omittedKeys?.includes(candidateKey)) {
      partnersToDisplay.push(candidateKey);
      sendPartnerSegmentEvent('Partner Impression', candidateKey);
    }
    if (partnersToDisplay.length === count) break;
  }
  return partnersToDisplay;
}

export default {
  isPartnersLive,
  isSitterPartnersLive,
  dismissPartner,
  getPartners,
  partnerClicked,
  sendPartnerSegmentEvent,
};
